package org.example.zone360.models

import kotlinx.serialization.Serializable

@Serializable
data class CreateCheckout(
    val checkout_url: String? = null,
    val error : String? = null
)